import { environment } from '../../environments/environment';

let constObject;
if (environment.production) {
	constObject = {
		// apiUrl: "https://mtstaging.lodgingsystem.com/api/",
		apiUrl: "http://mtstaging.lodgingsystem.com/api_ota/",
		url:"http://mtstaging.lodgingsystem.com/OTA/",
		current_version: '1',
		google_api_key:'AIzaSyCGbBWrVn3c6fPVQ8M3VKAmIgrllLcATqA',
		googleCaptchaSiteKey:'6LepMi0UAAAAAE2yjUh80ZWj1Wz6_lJ8tbcC5MQW'
	};
} else {
	constObject = {
		apiUrl: "http://localhost/lodgingsystem/ls-ota-pwa-api/",
		url: "/",
		current_version: '1',
		google_api_key:'AIzaSyCGbBWrVn3c6fPVQ8M3VKAmIgrllLcATqA',
		googleCaptchaSiteKey:'6LepMi0UAAAAAE2yjUh80ZWj1Wz6_lJ8tbcC5MQW'

	};
}

// Bed Types
let manhattan = [
	{'name' : 'King Bed', 'value' : 'King'},
	{'name' : 'Futon', 'value' : 'Futon'}
];
let coralhouse = [
	{'name' : '1 King', 'value' : 'King'},
	{'name' : '1 Queen', 'value' : 'Queen'},
	{'name' : '1 King Bed And 1 Queen Bed', 'value' : '1 King and 1 Queen'},
	{'name' : '2 Twin Beds', 'value' : '2 Twin beds'}
];
let villavenezia = [
	{'name' : '1 King', 'value' : 'King'},
	{'name' : '1 Queen Bed', 'value' : 'Queen'},
	{'name' : '1 King Bed and 1 Queen Bed', 'value' : '1 King and 1 Queen'},
	{'name' : '2 Twin Beds','value' :'2 Twin beds'}
];
let plazabeach = [
	{'name' : '1 KING', 'value' : 'King'},
    {'name' : '1 KING BED + 1 SLEEPER SOFA', 'value' : '1 King Bed + 1 Sleeper Sofa'},
    {'name' : '1 KING BED + 2 SLEEPER SOFA', 'value' : '1 King Bed + 2 Sleeper Sofa'},
    {'name' : '1 QUEEN BED', 'value' : 'Queen'},
    {'name' : '1 QUEEN BED + 1 SLEEPER SOFA', 'value' : '1 Queen Bed + 1 Sleeper Sofa'},
    {'name' : '1 QUEEN BED + 2 SLEEPER SOFA', 'value' : '1 Queen Bed + 2 Sleeper Sofa'},
    {'name' : '2 QUEEN BEDS + 1 SLEEPER SOFA', 'value' : '2 Queen Beds + 1 Sleeper Sofa'},
    {'name' : '2 QUEEN BEDS + 2 SLEEPER SOFA', 'value' : '2 Queen Beds + 2 Sleeper Sofa'},
    {'name' : '2 DOUBLE BEDS', 'value' : '2 Double Beds'},
    {'name' : '2 DOUBLE BEDS + 1 SLEEPER SOFA', 'value' : '2 Double Beds + 1 Sleeper Sofa'}
];
let skipjack = [
	{'name' : 'King Bed', 'value' : 'King'}
];
let casitas = [
	{
        'name' : 'One Queen Bed', 
        'value' : 'Queen'
    },
    {
        'name' : 'One Queen Bed and One Sleeper Sofa', 
        'value' : '1 Queen Bed + 1 Sleeper Sofa'
    },
    {
        'name' : 'One Queen Bed One King Bed and One Queen Sofa Sleeper', 
        'value' : '1 Queen Bed + 1 King Bed + 1 Queen Sofa Sleeper'
    },
    {
        'name' : 'Two Queen Beds and One Queen Sleeper Sofa', 
        'value' : '2 Queen Beds + 1 Sleeper Sofa'
    }
];
let roomTypesStatic = {
	116: manhattan,
	120: coralhouse,
	121: villavenezia,
	122: plazabeach,
	126: skipjack,
	128: casitas
}


// Amenities
let manhattanAmenity = [
	{'name' : 'Alarm Clock', 'value' : 'Alarm clock'},
	{'name' : 'Plunge Pool', 'value' : 'Plunge pool'},
	{'name' : 'Accessible Room', 'value' : 'Accessible room'}
];
let coralhouseAmenity = [
	{'name' : 'Pet Friendly', 'value' : 'Pet Friendly'},
	{'name' : 'Hair Dryer', 'value' : 'Hairdryer'},
	{'name' : 'Private Balcony', 'value' : 'Private Balcony'},
	{'name' : 'Free Wifi', 'value' : 'Free Wifi'},
	{'name' : 'Full kitchen', 'value' : 'Full kitchen'},
	{'name' : 'Jacuzzi bath Tub', 'value' : 'Jacuzzi bath tub'}
];
let villaveneziaAmenity = [
	{'name' : 'Hair Dryer', 'value' : 'Hairdryer'},
	{'name' : 'Private Balcony', 'value' : 'Private Balcony'},
	{'name' : 'Free Parking', 'value' : 'Free Parking'},
	{'name' : 'Full Kitchen', 'value' : 'Full kitchen'},
	{'name' : 'Jacuzzi Bath Tub', 'value' : 'Jacuzzi bath tub'},
	{'name' : 'Free Wifi', 'value' : 'Free Wifi'}
];
let plazabeachAmenity = [
	{'name' : 'PET FRIENDLY', 'value' : 'Pet Friendly'},
    {'name' : 'TIKI BAR', 'value' : 'Tiki Bar'},
    {'name' : 'FITNESS ROOM', 'value' : 'Fitness Room'},
    {'name' : 'BUSINESS CENTER', 'value' : 'Business Center'},
    {'name' : 'WATER ACTIVITIES', 'value' : 'Water Activities'},
    {'name' : 'FISHING', 'value' : 'Fishing'},
    {'name' : 'BOAT DOCK', 'value' : 'Boat Dock'}
];
let skipjackAmenity = [
	{'name' : 'Hair Dryer', 'value' : 'Hairdryer'},
	{'name' : 'Private Balcony', 'value' : 'Private Balcony'},
	{'name' : 'Free Wifi', 'value' : 'Free Wifi'},
	{'name' : 'Free Parking', 'value' : 'Free Parking'},
	{'name' : 'Kitchenette', 'value' : 'Kitchenette'}
];
let casitasAmenity = [
	{'name' : 'Hair Dryer', 'value' : 'Hairdryer'},
	{'name' : 'Wifi', 'value' : 'Wireless internet connection'}
];
let AmentiesTypesStatic = {
	116: manhattanAmenity,
	120: coralhouseAmenity,
	121: villaveneziaAmenity,
	122: plazabeachAmenity,
	126: skipjackAmenity,
	128: casitasAmenity
}


// View Types
let manhattanView = [];
let coralhouseView = [
	{'name' : 'Garden view', 'value' : 'Garden view'},
	{'name' : 'Waterfront view', 'value' : 'Water view'}
];
let villaveneziaView = [
	{'name' : 'Garden View', 'value' : 'Garden view'},
	{'name' : 'WaterFront View', 'value' : 'Water view'}
];
let plazabeachView = [
	{'name' : 'BAY SIDE HOTEL', 'value' : 'Bay view'},
    {'name' : 'BEACH SIDE HOTEL', 'value' : 'Beach view'}
];
let skipjackView = [
{'name' : 'Garden view', 'value' : 'Garden view'}, 
{'name' : 'Waterfront view', 'value' : 'Water view'}
];
let casitasView = [
	{
        'name' : 'Poolside and Courtyard Views', 
        'value' : 'Poolside and Courtyard Views'
    },
    {
        'name' : 'Courtyard View', 
        'value' : 'Courtyard view'
    }
];
let viewTypesStatic = {
	116: manhattanView,
	120: coralhouseView,
	121: villaveneziaView,
	122: plazabeachView,
	126: skipjackView,
	128: casitasView
}


export const constVariables = {
	apiUrl: constObject.apiUrl,
	url: constObject.url,
	current_version : constObject.current_version,
	roomTypes : roomTypesStatic,
	amentiesTypes : AmentiesTypesStatic,
	viewTypes : viewTypesStatic,
	googleApiKey:constObject.google_api_key,
	googleCaptchaSiteKey: constObject.googleCaptchaSiteKey,
	mh_cam1_url: 'https://www.manhattantowerfl.com/kurento/?id=mh_1',
    mh_cam2_url: 'https://www.manhattantowerfl.com/kurento/?id=mh_2'
};